import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-enterprise';

import { IconSpriteModule } from 'ng-svg-icon-sprite';

@Component({
    selector: 'image-header-renderer',
    templateUrl: 'image-header-renderer.component.html',
    styleUrls: ['./image-header-renderer.component.scss'],
    imports: [IconSpriteModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageHeaderRendererComponent implements IHeaderAngularComp {

  params!: IHeaderParams;
  iconSrc = signal<string>('');
  imageTitle = signal<string>('');
  sortDirection = signal<'asc' | 'desc' | null>(null);

  agInit(params: IHeaderParams): void {
    this.params = params;
    this.setParameters();
    params.column.addEventListener('sortChanged', this.onSortChanged.bind(this));
    this.onSortChanged();
  }

  private setParameters(): void {
    const p = this.params as any;
    const filename: string = p.rendererImageFilename ?? '';
    this.iconSrc.set(filename ? 'assets/sprites/sprite.svg#' + filename.replace('.svg', '') : '');
    this.imageTitle.set(p.imageTitle ?? this.params.displayName);
  }

  onSortChanged(): void {
    this.sortDirection.set(this.params.column.getSort() ?? null);
  }

  onSortRequested(event: MouseEvent): void {
    this.params.progressSort(event.shiftKey);
  }

  refresh(params: IHeaderParams): boolean {
    this.params = params;
    this.setParameters();
    return true;
  }
}
